/*
 * @Author: tao_yang
 * @Date: 2023-02-17 18:33:56
 * @LastEditors: tao_yang
 * @LastEditTime: 2023-03-13 17:34:03
 * @Description: 请填写简介
 */
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
// import useReStoreScrollTop from '@/utils/customHooks/useScrollToTop';
import IntelligentDesignPad from '&/pages/landing-page/IntelligentDesignPad';
import businessCooperation from '&/pages/landing-page/businessCooperation';
import aboutFoxitHD from '&/pages/landing-page/aboutFoxitHD';
import Solution from '&/pages/landing-page/solution';
import LandingPage from './LandingPage';
import MarketingDesign from '&/pages/landing-page/marketingDesign';
import Channel from '&/pages/landing-page/channel';
import Combo from '&/pages/landing-page/FamilyBucket';
import AssembledCeiling from '&/pages/landing-page/assembledCeiling';
import PramsEdit from '&/pages/landing-page/paramsEdit';
import TechnicalAuth from '&/pages/landing-page/technicalAuth';
import MaterialDownload from '&/pages/landing-page/materialDownload';
import ElectronicDrawing from '&/pages/landing-page/digitalDrawing';

export default function () {
    // 二级路由
    const ROUTES = [
        {
            path: '/landing/index',
            component: LandingPage,
        },
        {
            path: '/landing/IntelligentDesignPad',
            component: IntelligentDesignPad,
        },
        {
            path: '/landing/businessCooperation',
            component: businessCooperation,
        },
        {
            path: '/landing/merchantWillMoveInto',
            component: businessCooperation,
        },
        {
            path: '/landing/aboutFoxitHD',
            component: aboutFoxitHD,
        },
        {
            path: '/landing/solution',
            component: Solution,
        },
        {
            path: '/landing/marketingDesign',
            component: MarketingDesign,
        },
        {
            path: '/landing/channel',
            component: Channel,
        },
        {
            path: '/landing/combo',
            component: Combo,
        },
        {
            path: '/landing/ceiling',
            component: AssembledCeiling,
        },
        {
            path: '/landing/paramsEdit',
            component: PramsEdit,
        },
        {
            path: '/landing/technicalAuth',
            component: TechnicalAuth,
        },
        {
            path: '/landing/materialDownload',
            component: MaterialDownload,
        },
        {
            path: '/landing/digitalDrawing',
            component: ElectronicDrawing,
        },
    ];
    const [{ path: SUB_HOME }] = ROUTES;
    const { pathname } = useLocation();

    // 兼容带 index.html 后缀的访问路径（nginx 会将 /landing/xxx/index.html
    // 同样返回首页 HTML，浏览器地址栏仍保留该后缀）：
    // 去掉末尾 /index.html 后缀后，若命中已有 landing 路由则重定向到该路由；
    // 否则走下方默认重定向，回到 /landing/index。
    const htmlSuffixTarget = (() => {
        if (!/\/index\.html$/.test(pathname)) return null;
        const stripped = pathname.replace(/\/index\.html$/, '');
        return ROUTES.some(item => item.path === stripped) ? stripped : null;
    })();

    // useReStoreScrollTop();

    return (
        <Switch>
            {ROUTES.map((item, idx) => (
                <Route
                    exact
                    key={idx}
                    path={item.path}
                    children={<item.component />}
                />
            ))}
            {htmlSuffixTarget && <Redirect to={htmlSuffixTarget} />}
            <Redirect to={SUB_HOME} />
        </Switch>
    );
}
